export function randomString(length: number = 8) {
  const array = new Uint8Array(length);
  window.crypto.getRandomValues(array);
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

  return Array.from(array, (byte) => characters[byte % characters.length]).join('');
}
